import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ExpenseReportQuery,
  ExpenseReportResponse,
  NRTReportResponse,
  PayloadParam,
  ReportResponse,
  UpdateNotePayload,
  UpdateNoteResponse,
} from '@core/interface/report';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getReports(param: PayloadParam) {
    let httpParams = new HttpParams();
    if (param)
      Object.keys(param).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (param[key as keyof PayloadParam] as any) || ''
        );
      });
    return this.http.get<ReportResponse>(environment.endPoints.labourReport, {
      params: httpParams,
    });
  }

  updateNote(data: UpdateNotePayload | PayloadParam) {
    return this.http.post<UpdateNoteResponse>(
      environment.endPoints.addReportNote,
      data
    );
  }

  getNRTReports(param: PayloadParam) {
    let httpParams = new HttpParams();
    if (param)
      Object.keys(param).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (param[key as keyof PayloadParam] as any) || ''
        );
      });
    return this.http.get<NRTReportResponse>(
      environment.endPoints.nrtTimesheetReport,
      {
        params: httpParams,
      }
    );
  }

  getExpenseReports(param: ExpenseReportQuery) {
    let httpParams = new HttpParams();
    if (param)
      Object.keys(param).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (param[key as keyof ExpenseReportQuery] as any) || ''
        );
      });
    return this.http.get<ExpenseReportResponse>(
      environment.endPoints.nrtExpenseReport,
      {
        params: httpParams,
      }
    );
  }
}
